
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 400 300"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3a75c4","d":"M0 0h400v300H0z"}}),_c('path',{attrs:{"fill":"#fcd116","d":"M0 0h400v200H0z"}}),_c('path',{attrs:{"fill":"#009e60","d":"M0 0h400v100H0z"}})])
          )
        }
      }
    